module.exports = __webpack_public_path__ + "static/media/ic-flexi.454273a5.svg";